import { Chip } from "@mui/material";
import { FC, useMemo } from "react";
import { FeedbackStatus, FeedbackType } from "types/feedback";
import { getFeedbackStatus } from "utils/feedback";

type FeedbackStatusChipProps = {
  feedback: FeedbackType;
  size?: "small" | "medium";
};

export const FeedbackStatusChip: FC<FeedbackStatusChipProps> = ({
  feedback,
  size = "medium",
}) => {
  const status: FeedbackStatus = getFeedbackStatus(feedback) as FeedbackStatus;
  const statusLabel = useMemo(() => {
    switch (status) {
      case FeedbackStatus.PENDING:
        return "Pending";
      case FeedbackStatus.DONE:
        return "Done";
      case FeedbackStatus.EXPIRED:
        return "Expired";
      case FeedbackStatus.MISSING_INFO:
        return "Missing Info";
      case FeedbackStatus.DECLINED:
        return "Declined";
      case FeedbackStatus.DRAFT:
        return "Draft";
      case FeedbackStatus.ARCHIVED:
        return "Archived";
      case FeedbackStatus.HIDDEN:
        return "Hidden";
    }
  }, [status]);
  const chipColor = useMemo(() => {
    switch (status) {
      case FeedbackStatus.PENDING:
        return "warning";
      case FeedbackStatus.DONE:
        return "success";
      case FeedbackStatus.EXPIRED:
      case FeedbackStatus.DECLINED:
        return "error";
      case FeedbackStatus.DRAFT:
      case FeedbackStatus.ARCHIVED:
      case FeedbackStatus.HIDDEN:
      case FeedbackStatus.MISSING_INFO:
        return "secondary";
    }
  }, [status]);
  const chipVariant = useMemo(() => {
    switch (status) {
      case FeedbackStatus.DRAFT:
        return "outlined";
      default:
        return "filled";
    }
  }, [status]);

  return (
    <Chip
      component={"span"}
      label={statusLabel}
      color={chipColor}
      variant={chipVariant}
      size={size}
    />
  );
};
